import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

//Components
import { VentajasServicioComponent } from 'src/app/components/ventajas-servicio/ventajas-servicio.component';
import { CarritoCardComponent } from './carrito-card/carrito-card.component';

//Material
import {MatCardModule} from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule, Routes } from '@angular/router';

import { NumberDirective } from '../directives/only-numbers.directive';
import { NoticiaBlogComponent } from './noticia-blog/noticia-blog.component';
import { AvacomCartModalComponent } from './avacom-cart-modal/avacom-cart-modal.component';
import { CondicionesComponent } from '../pages/avacom/condiciones/condiciones.component';

@NgModule({
  declarations: [
    VentajasServicioComponent,
    CarritoCardComponent,
    NumberDirective,
    NoticiaBlogComponent,
    AvacomCartModalComponent,
    CondicionesComponent
  ],
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    RouterModule.forRoot([], {scrollPositionRestoration: 'enabled'})
  ],
  exports: [
    VentajasServicioComponent,
    CarritoCardComponent,
    NumberDirective,
    NoticiaBlogComponent,
    CondicionesComponent
  ]
})
export class SharedModule { }
